import { useEffect } from 'react';
import { mountAutoEllipsisTitle } from '@/utils/autoEllipsisTitle';

/**
 * 全局挂载：截断文案悬停自动显示完整 title。
 * 挂一次即可覆盖 Temu / Shein / 管理端等所有表格页面。
 */
export default function AutoEllipsisTitle() {
  useEffect(() => mountAutoEllipsisTitle(document), []);
  return null;
}
